import { render, staticRenderFns } from "./openpay-charge.vue?vue&type=template&id=49ae2d5e&"
import script from "./openpay-charge.vue?vue&type=script&lang=js&"
export * from "./openpay-charge.vue?vue&type=script&lang=js&"
import style0 from "./openpay-charge.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports